export default __webpack_public_path__ + "static/media/fasting_18_6@2x.3e1c339b.jpg";